import React, { Component } from 'react';
import { connect } from 'react-redux';
import Navbar from '../../components/private/Navbar';
import VerticalNavbar from '../../components/private/VerticalNavbar';
import SimpleSnackbar from '../../components/SimpleSnackbar';
import { handleNavbar } from '../../modules/user/redux/action';
import '../../style';
import { userDetail } from "../../../src/config/userDetails";
import { Redirect } from "react-router-dom";

class PrivateLayout extends Component {
    constructor (props) {
        super(props)
        this.state = {
            showDrawer: false
        }
    }
    drawerStateHAndle = () => {
        this.props.handleNavbar(false)
        this.setState({showDrawer: !this.state.showDrawer})
    }
    callback = () => {
        if(!userDetail().subscriptionId){
            window.location.href = "/counterpartybillings";
           }
    }
    componentDidMount(){
        if(userDetail().roleName==="COUNTER_PARTY"){
        if(window.location.href.includes("counterpartybillings")){
            document.removeEventListener("click", this.callback);
        }
        else{
            document.addEventListener("click", this.callback);
        }
    }

    }
    render() {
        const Component = this.props.component;
        const route = this.props.route;
        console.log(route.match.path!=="/counterpartybillings",'route')
        if (userDetail().roleName==="COUNTER_PARTY" && !userDetail().subscriptionId && route.match.path!=="/counterpartybillings" ) {
            return <Redirect to="/counterpartybillings" />;
          }
        return (
            <div className="app-body">
                <SimpleSnackbar />
                <VerticalNavbar showDrawer={this.state.showDrawer} handleClick={this.drawerStateHAndle}/>
                <div className="app-body-left">
                    <Navbar showDrawer={this.drawerStateHAndle} route={route} />
                    <main><Component route={route} /></main>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, props) { return { user: state.userData } }

export default connect(
    mapStateToProps,
    { handleNavbar }
)(PrivateLayout);


// WEBPACK FOOTER //
// ./src/template/private/index.js